import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { Betalningsvyer } from './Betalning/Betalning';
import { Betalningsuppdragsvyer } from './Utbetalningsorder/Betalningsuppdrag';
import { Leverantorsvyer } from './Leverantor/Leverantor';
import { LeverantorsfakturaVyer } from './LeverantorFaktura/Leverantorfaktura';
import { LeverantorkatVyer } from './LeverantorKategori/Leverantorkat';
import { FakturaDelVyer } from './FakturaDel/FakturaDel';
import { initConst } from '../../../../Utils/utils';
import { FakturaDokVyer } from './FakturaDok/FakturaDok';
import { AttestantVyer } from './Attestant/Attestant';
import { LeverantorAttestVyer } from './LeverantorAttest/LeverantorAttest';

export const LRVyer = initConst<IComponentsConfig>(() => ({
  LRBetalning: Betalningsvyer,
  LRBetalningsuppdrag: Betalningsuppdragsvyer,
  LRLeverantor: Leverantorsvyer,
  LRLeverantorfaktura: LeverantorsfakturaVyer,
  LRLeverantorkat: LeverantorkatVyer,
  LRFakturaDel: FakturaDelVyer,
  LRFakturaDok: FakturaDokVyer,
  LRAttestant: AttestantVyer,
  LRLeverantorAttest: LeverantorAttestVyer,
}));
